import { ReactElement } from 'react';

import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { WaitlistEntryConfirmReservationModal } from './WaitlistEntryConfirmReservationModal';

type WaitlistEntryConfirmReservationModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type WaitlistEntryConfirmReservationModalOpenerProps = {
   children: (renderProps: WaitlistEntryConfirmReservationModalOpenerChildrenRenderProps) => ReactElement;
   waitlistEntry: WaitlistEntry;
};

export const WaitlistEntryConfirmReservationModalOpener = (
   props: WaitlistEntryConfirmReservationModalOpenerProps
): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <WaitlistEntryConfirmReservationModal onClose={closeModal} waitlistEntry={props.waitlistEntry} />
         ) : null}
      </>
   );
};
